import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useSearchOrders = (params: any) => {
    const { data, isLoading } = useQuery({
        queryKey: ['search-orders', params],
        queryFn: async () => await apiClient.get(`order-search/dealer-orders`,
            {
                params: params
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
